import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import React  from 'react';
import { FormattedNumber } from '../../components/primitives/FormattedNumber';

export interface IValueInformerProps {
  caption: string;
  value: string | number;
  symbol?: string;
  percent?: boolean;
}

export const ValueInformer = ({ caption, value, symbol, percent }: IValueInformerProps) => {
  const { breakpoints } = useTheme();
  const md = useMediaQuery(breakpoints.up('md'));
  return (
    <Box>
      <Typography
        variant={md ? 'secondary13' : 'secondary12'}
        color="text.secondary"
      >
        {caption}
      </Typography>
      <FormattedNumber
        value={value}
        symbol={symbol}
        variant={md ? 'secondary15' : 'secondary14'}
        percent={percent}
        compact
      />
    </Box>
  );
}
